import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionService } from 'app/services/models/action.service';
import { KindService } from 'app/services/models/kind.service';
import { PersonService } from 'app/services/models/person.service';
import { RequestTaskService } from 'app/services/models/request-task.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-action',
  templateUrl: './create-action.component.html',
  styleUrls: ['./create-action.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateActionComponent implements OnInit {
  @Input() data: { requestTask: any; actionId: number };

  persons: any[] = [];
  selectedCompanyPerson: any[] = [];
  kinds: any[] = [];

  actionForm: FormGroup; // Form için tanımlama
  @BlockUI('card-section') blockUI: NgBlockUI;

  constructor(
    public activeModal: NgbActiveModal,
    private personService: PersonService,
    private kindService: KindService,
    private actionService: ActionService,
    private toastrService: ToastrService,
    private requestTaskService: RequestTaskService,
    private fb: FormBuilder) {

    this.actionForm = this.fb.group({
      title: ['', Validators.required],
      typeId: [null, Validators.required],
      startDate: [null],
      endDate: [null],
      responsiblePerson: [null],
      companyPerson: [null],
      priority: ['1', Validators.required],
      status: ['1', Validators.required],
      description: [null]
    });
  }

  date = new Date();
  date2 = moment().add(15, 'days').toDate();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,

  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  async ngOnInit() {
    console.log(this.data);
    await this.getAllPersons(1);
    await this.getAllPersons(this.data.requestTask.companyId);
    await this.getAllKinds();
    if (this.data.actionId) {
      await this.getByIdAction(this.data.actionId);
    }
  }

  async getByIdAction(id) {
    this.blockUI.start("Aksiyon yükleniyor");
    const data = await this.actionService.getByIdAction(id);
    console.log(data);
    if (data) {
      this.actionForm.patchValue({
        title: data.title,
        typeId: data.kindId,
        startDate: data.startDate,
        endDate: data.finishDate,
        responsiblePerson: data.responsiblePersonId,
        priority: data.priority,
        companyPerson: data.personId,
        description: data.description,
        status: data.status
      });
      this.date = new Date(data.startDate);
      this.date2 = new Date(data.finishDate);
    }
    this.blockUI.stop();
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 10);
    this.kinds = data.types;
    console.log(this.kinds);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async getAllPersons(id: number) {
    const data = await this.personService.getByIdCompanyPersons(id);
    if (id == 1) {
      this.persons = data;
      console.log(this.persons);
    } else {
      this.selectedCompanyPerson = data;
      console.log(this.selectedCompanyPerson);
    }
  }

  async onSubmit() {
    if (this.actionForm.valid) {
      const formData = this.actionForm.value;
      const startDate = new Date(formData.startDate);
      const endDate = new Date(formData.endDate);
      if (this.data.actionId) {
        this.blockUI.start("Aksiyon güncelleniyor...");
        const response = await this.actionService.updateAction(this.data.actionId, formData.title, formData.typeId, formData.priority, formData.status, formData.responsiblePerson, formData.companyPerson, formData.description);
        if (response.status) {

          this.requestTaskService.sendEvent(this.data.requestTask.id);
          this.toastrService.success(response.message);
          this.closeModal();
          this.blockUI.stop();
        } else {
          this.toastrService.error(response.message);
          this.blockUI.stop();
        }
      } else {
        this.blockUI.start("Aksiyon oluşturuluyor...");
        const response = await this.actionService.createActions(this.data.requestTask.id, formData.title, formData.typeId, formData.priority, 1, formData.responsiblePerson, formData.companyPerson, startDate, endDate, formData.description);
        if (response.status) {
          this.requestTaskService.sendEvent(this.data.requestTask.id);
          this.toastrService.success(response.message);
          this.closeModal();
          this.blockUI.stop();
        } else {
          this.toastrService.error(response.message);
          this.blockUI.stop();
        }
      }
      this.blockUI.stop();
    } else {
      this.toastrService.error("Formu doğru doldurunuz.")
    }
    this.blockUI.stop();
  }
}